// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import AccountSideMenu from 'Containers/AccountSideMenu/AccountSideMenu';
import ServiceComponent from 'Components/Service/Service';

const StyledServicePage = styled.div`
  display: grid;
  grid-template-columns: 260px auto;
  grid-column-gap: 30px;

  @media screen and (max-width: 1024px) {
    grid-template-columns: auto;

    aside {
      display: none;
    }
  }
`;

const ServicePage = memo(() => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { bodyAttributes } = Helmet.peek() || {};

  let servicePageClassName = bodyAttributes?.class || '';
  if (!servicePageClassName.includes('ServicePage')) {
    servicePageClassName += 'ServicePage';
  }

  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, interactive-widget=resizes-content" />
        <body className={ servicePageClassName } />
        <title>{ t('common.pages.rma') }</title>
      </Helmet>
      <StyledServicePage theme={ theme } className="grid-container">
        <AccountSideMenu />
        <ServiceComponent />
      </StyledServicePage>
    </>
  );
});
ServicePage.displayName = 'ServicePage';

export default ServicePage;
